import { PermissionGuard } from '@/features/auth';
import { Button } from '@/shared/components';
import { useConfirmedAction } from '../hooks/useConfirmedAction';
import { useDiscardDraftMutation } from '../hooks/useDraftMutations';
import { TemplateActionConfirm } from './TemplateActionConfirm';

interface Props {
  templateId: string;
  draftVersionNumber: number;
  className?: string;
}

export function DiscardDraftAction({ templateId, draftVersionNumber, className = '' }: Props) {
  const discard = useConfirmedAction(useDiscardDraftMutation(templateId));

  return (
    <PermissionGuard permission={{ resource: 'document_template', action: 'edit' }}>
      <Button type="button" variant="danger" appearance="outline" size="sm" className={className} onClick={discard.open}>
        Discard draft
      </Button>
      <TemplateActionConfirm
        isOpen={discard.isOpen}
        title="Discard this draft?"
        message={`Draft version ${draftVersionNumber} and any unsaved edits will be permanently lost.`}
        confirmLabel="Discard draft"
        isPending={discard.isPending}
        error={discard.error}
        onConfirm={() => discard.confirm()}
        onClose={discard.close}
      />
    </PermissionGuard>
  );
}
